import React from "react";
import {
  PromptInput,
  PromptInputBody,
  PromptInputTextarea,
  PromptInputFooter,
  PromptInputTools,
  PromptInputButton,
  PromptInputSubmit,
  PromptInputAttachments,
  PromptInputAttachment,
  type PromptInputMessage,
} from "@/components/ai-elements/prompt-input";
import { MicIcon, PlusIcon } from "lucide-react";

interface PromptInputConciergeProps {
  placeholder?: string;
  onSubmit: (text: string) => void;
  disabled?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  onAttachClick?: () => void;
  onMicClick?: () => void;
  isStreaming?: boolean;
}

export const PromptInputConcierge: React.FC<PromptInputConciergeProps> = ({
  placeholder = "Ask anything",
  onSubmit,
  disabled = false,
  isStreaming = false,
  value,
  onChange,
}) => {
  const handleSubmit = (message: PromptInputMessage) => {
    if (message.text && message.text.trim()) {
      onSubmit(message.text);
    }
  };

  const status = isStreaming ? "streaming" : "ready";

  return (
    <div className="tw:mx-auto tw:w-full tw:max-w-[900px]">
      <PromptInput onSubmit={handleSubmit} multiple globalDrop>
        <PromptInputBody>
          <PromptInputAttachments>
            {(attachment) => <PromptInputAttachment data={attachment} />}
          </PromptInputAttachments>
          <PromptInputTextarea
            placeholder={placeholder}
            disabled={disabled}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            rows={1}
            className="min-h-10! max-h-48 resize-none"
          />
        </PromptInputBody>
        <PromptInputFooter>
          <PromptInputTools>
            {/* Disabled until we support image upload */}
            <PromptInputButton disabled onClick={() => console.log("Attach clicked")}>
              <PlusIcon size={16} />
            </PromptInputButton>
            {/* Disabled until we support audio input*/}
            <PromptInputButton disabled onClick={() => console.log("Mic clicked")}>
              <MicIcon size={16} />
            </PromptInputButton>
          </PromptInputTools>
          <PromptInputSubmit disabled={disabled || isStreaming} status={status} />
        </PromptInputFooter>
      </PromptInput>
    </div>
  );
};
